import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { NotificationsService } from './services/notifications.service';
import { addIcons } from 'ionicons';
import { 
  notificationsOutline,
  menu,
  close,
  person,
  people,
  cube,
  checkmarkCircle,
  pricetag,
  warning,
  cloudUpload,
  star
} from 'ionicons/icons';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private notificationsService = inject(NotificationsService);
  private logoutTimerId: any = null;

  constructor() {
    // Mantén el modo oscuro
    document.body.classList.add('dark');
    
    // Registrar iconos globalmente para evitar errores de "Invalid base URL"
    addIcons({
      notificationsOutline,
      menu,
      close,
      person,
      people,
      cube,
      checkmarkCircle,
      pricetag,
      warning,
      cloudUpload,
      star
    });
    
    // Configurar StatusBar para iOS
    this.initializeStatusBar();
  }

  async initializeStatusBar() {
    if (Capacitor.isNativePlatform()) {
      try {
        // Configurar StatusBar con negro puro para coincidir con Dynamic Island
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#000000' });
        // Overlay en false para evitar que el contenido se superponga con el StatusBar
        await StatusBar.setOverlaysWebView({ overlay: false });
      } catch (error) {
        console.log('StatusBar no disponible:', error);
      }
    }
  }

  ngOnInit(): void {
    this.enforceSessionOnStartup();
    this.scheduleAutoLogout();
    this.setupNotifications();
    
    // Escuchar cuando la app se vuelve activa (desde iOS)
    if (Capacitor.isNativePlatform()) {
      window.addEventListener('appDidBecomeActive', () => {
        console.log('📱 App se volvió activa, recargando notificaciones...');
        this.notificationsService.loadNotifications();
      });
    }
  }

  private setupNotifications() {
    // Cargar notificaciones al iniciar la app si hay usuario logueado
    const user = localStorage.getItem('user');
    if (user) {
      // Esperar un poco para que el servicio esté listo
      setTimeout(() => {
        this.notificationsService.loadNotifications();
      }, 1000);
    }
  }

  private enforceSessionOnStartup() {
    const exp = localStorage.getItem('session_expiration');
    const user = localStorage.getItem('user');
    if (!exp || !user || Date.now() >= Number(exp)) {
      this.clearSessionAndRedirect();
    }
  }

  private scheduleAutoLogout() {
    if (this.logoutTimerId) {
      clearTimeout(this.logoutTimerId);
      this.logoutTimerId = null;
    }
    const exp = localStorage.getItem('session_expiration');
    if (!exp) return;
    const msLeft = Number(exp) - Date.now();
    if (msLeft <= 0) {
      this.clearSessionAndRedirect();
      return;
    }
    this.logoutTimerId = setTimeout(() => this.clearSessionAndRedirect(), msLeft);
  }

  private clearSessionAndRedirect() {
    localStorage.removeItem('user');
    localStorage.removeItem('session_expiration');
    this.router.navigate(['/login']);
  }
}
